module.exports = __webpack_public_path__ + "h5/img/money.136360a9.png";